import "./header.css";
import "./livecloock";
import LiveCloock from "./livecloock";

const Header = () => {
  return (
    <header className="header">
      <div className="logo">영암풍력발전 맞춤형 기상기후서비스</div>
      <ul className="info">
        <li>
          <a
            className="infomation"
            href="https://data.kma.go.kr/normals/table.do"
            rel="noopener noreferrer"
            target="blank"
            title="기상청 기후평년값 바로가기"
          >
            기후(통계)정보
          </a>
        </li>
        <li className="today">
          <LiveCloock />
        </li>
      </ul>
    </header>
  );
};

export default Header;
